'use es6';

// Scrolls to the element specified in `#hsScrollTo=<id>` before most other IPEUI JS,
// so that the scroll post-iframe reload happens quickly (and doesn't wait on all that other
// JS to run and for the iframe to "handshake" with the parent)
const SCROLL_TO_PATTERN = /\bhsScrollTo=([\d.]+),([\d.]+)/;
const extractScrollYAndRemoveFromHash = () => {
  const matches = window.location.hash.match(SCROLL_TO_PATTERN);
  if (matches) {
    const [wholeMatch, scrollX, scrollY] = matches;
    window.location.hash = window.location.hash.replace(wholeMatch, '');
    return {
      scrollX: parseFloat(scrollX),
      scrollY: parseFloat(scrollY)
    };
  }
  return {
    scrollX: 0,
    scrollY: 0
  };
};
let isScrollingPostLoad = true;
let scrollPollInterval;
let ignoreNextScrollEvent = false;
const scrollIfDocumentHeightIsBigEnough = (left, top) => {
  if (isScrollingPostLoad) {
    const currentScrollX = window.pageXOffset;
    const currentScrollY = window.pageYOffset;

    // Only scroll if the doc isn't already there and if the document is big enough yet
    if (left !== currentScrollX || top !== currentScrollY) {
      const documentHeight = document.documentElement.scrollHeight;
      if (documentHeight > top) {
        ignoreNextScrollEvent = true;
        window.scrollTo(left, top);
      }
    }
  }
};

/* Allow hoisted functions to be used before defined */
/* eslint no-use-before-define: ["error", { "functions": false }] */
function handleNextScrollHelper() {
  if (ignoreNextScrollEvent) {
    ignoreNextScrollEvent = false;
  } else {
    stopAllScrolling();
  }
}
function cancelScrollingOnNextUserScroll() {
  return window.addEventListener('scroll', handleNextScrollHelper);
}
function stopIncrentalPreLoadScrolling() {
  clearInterval(scrollPollInterval);
}
function stopAllScrolling() {
  stopIncrentalPreLoadScrolling();
  isScrollingPostLoad = false;
  window.removeEventListener('scroll', handleNextScrollHelper);
}
const scrollOnFormLoad = (scrollX, scrollY) => {
  if (window.hubspot.form && window.hubspot.form.api) {
    window.hubspot.form.api.onFormReady(() => {
      scrollIfDocumentHeightIsBigEnough(scrollX, scrollY);
    });
  }
};
const startIncrementalScrollUntilLoad = () => {
  const {
    scrollX,
    scrollY
  } = extractScrollYAndRemoveFromHash();
  if ((scrollX == null || scrollX === 0) && (scrollY == null || scrollY === 0)) {
    isScrollingPostLoad = false;
    return;
  }
  scrollIfDocumentHeightIsBigEnough(scrollX, scrollY);
  scrollPollInterval = setInterval(scrollIfDocumentHeightIsBigEnough.bind(null, scrollX, scrollY), 200);
  scrollOnFormLoad(scrollX, scrollY);

  // Stop scroll interval on load
  window.addEventListener('load', () => {
    stopIncrentalPreLoadScrolling();

    // One last scroll, just in case
    scrollIfDocumentHeightIsBigEnough(scrollX, scrollY);

    // Only allow other scrolling (post-form load, etc) to happen for a period of time after
    // the load event finishes
    setTimeout(stopAllScrolling, 5000);
  });
  cancelScrollingOnNextUserScroll();
};
export const scrollToPositionInHash = () => {
  // Wait till the document has been parsed until we start scrolling
  if (document.readyState !== 'loading') {
    startIncrementalScrollUntilLoad();
  } else {
    document.addEventListener('DOMContentLoaded', startIncrementalScrollUntilLoad);
  }
};
export const setCurrentScrollPositionInHash = () => {
  const scrollHash = `hsScrollTo=${window.scrollX},${window.scrollY}`;
  window.document.location.hash = scrollHash;
};
export const appendCurrentScrollPositionHashToUrl = url => {
  if (url.includes('#')) {
    url = url.slice(0, url.lastIndexOf('#'));
  }
  return `${url}#hsScrollTo=${window.scrollX},${window.scrollY}`;
};